import DataStructure, { sanitize } from "./DataStructure";
import { deepFreeze, timestampToDate } from "../util/misc";

export const PROJECT_EMAIL_FIELDS = {
  messageId: "",
  internetMessageId: "",
  conversationId: "",
  subject: "",
  from: null,
  toRecipients: [],
  ccRecipients: [],
  bodyPreview: "",
  body: "",
  bodyType: "text",
  hasAttachments: false,
  attachments: [],
  receivedDateTime: null,
  created: null,
};
deepFreeze(PROJECT_EMAIL_FIELDS);

export default class ProjectEmail extends DataStructure {
  constructor(id, data = {}, projectID = null) {
    data = sanitize(data, PROJECT_EMAIL_FIELDS);

    // Convert to Date
    data.receivedDateTime = timestampToDate(data.receivedDateTime);
    data.created = timestampToDate(data.created);

    super(data);

    this.id = id || null;
    this.projectID = projectID || null;
  }

  // Database

  get stateID() {
    return this.projectID + this.id;
  }

  static getStateID(path) {
    const match = path.match(/^projects\/([^/]+)\/emails\/([^/]+)$/);
    if (match) {
      return match[1] + match[2];
    }
    return path;
  }

  get path() {
    return ProjectEmail.getPath(this.projectID, this.id);
  }

  static getPath(projectID, id) {
    let path = `projects/${projectID}/emails`;
    if (id) {
      path += `/${id}`;
    }
    return path;
  }

  static toFirestore(email) {
    return email.data;
  }

  static fromFirestore(snapshot, options) {
    const data = snapshot.data(options);
    const projectID = snapshot.ref.parent.parent.id;
    return new ProjectEmail(snapshot.id, data, projectID);
  }

  // Formatting

  get fromDisplay() {
    if (!this.data.from) return "";
    return this.data.from.name || this.data.from.address || "";
  }

  get fromAddress() {
    return this.data.from ? this.data.from.address : "";
  }

  toString() {
    return this.data.subject;
  }
}
